import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface MetricCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  trend?: string;
  variant?: 'default' | 'warning' | 'success';
}

export function MetricCard({ title, value, icon, trend, variant = 'default' }: MetricCardProps) {
  return (
    <Card className={cn(
      "overflow-hidden",
      variant === 'warning' && "border-warning",
      variant === 'success' && "border-success"
    )}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground font-medium">{title}</p>
            <p className="text-3xl font-bold">{value}</p>
            {trend && (
              <p className="text-xs text-muted-foreground">{trend}</p>
            )}
          </div>
          <div className={cn(
            "p-3 rounded-full",
            variant === 'warning' && "bg-warning/10 text-warning",
            variant === 'success' && "bg-success/10 text-success",
            variant === 'default' && "bg-primary/10 text-primary"
          )}>
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
